import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TogglePilotPanel, PilotPanelExtendedChangedByServerAction } from './pilot-panel.actions';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { Injectable } from '@angular/core';
import { BrickWallService } from 'src/generated/swagger';

export interface PilotPanelStateModel {
   isExtended: boolean;
}

@State<PilotPanelStateModel>({
   name: 'pilotPanel',
   defaults: {
      isExtended: true,
   },
})
@Injectable()
export class PilotPanelState {
   constructor(private brickWallService: BrickWallService) {}

   @Selector([PilotPanelState])
   public static isPilotPanelExtended(state: PilotPanelStateModel) {
      return state.isExtended;
   }

   @Action(TogglePilotPanel)
   @ImmutableContext()
   public togglePilotPanel(ctx: StateContext<PilotPanelStateModel>, action: TogglePilotPanel) {
      ctx.setState((state: PilotPanelStateModel) => {
         state.isExtended = !state.isExtended;
         return state;
      });
      return this.brickWallService.pilotPanelExtended({ isPilotPanelExtended: ctx.getState().isExtended });
   }

   @Action(PilotPanelExtendedChangedByServerAction)
   @ImmutableContext()
   public PilotPanelExtendedByServer(ctx: StateContext<PilotPanelStateModel>, action: PilotPanelExtendedChangedByServerAction) {
      ctx.setState((state: PilotPanelStateModel) => {
         state.isExtended = action.isPilotPanelExtended;
         return state;
      });
   }
}
